import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "inputTitle" }
const _hoisted_5 = { class: "inputField flex-grow" }
const _hoisted_6 = { class: "error-msg" }
const _hoisted_7 = { class: "inputTitle" }
const _hoisted_8 = { class: "inputField flex-grow" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-4 w-full mt-6" }
const _hoisted_10 = { class: "text-grey mb-4" }
const _hoisted_11 = { class: "flex mb-4" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "inputField" }
const _hoisted_14 = { class: "inputTitle ml-2" }
const _hoisted_15 = { for: "activityFilterToggle" }
const _hoisted_16 = { class: "ml-auto" }
const _hoisted_17 = { class: "text-center" }

import {ErrorLocationType, TableType} from '@/utilities/enums/Enums';
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Store} from "@bryntum/grid";
import GridInputFilter from "@/components/GridInputFilter";
import {computed, onBeforeUnmount, onMounted, reactive, ref, toRef} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {useI18n} from "vue-i18n";
import Tags from "@/components/inputs/Tags";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import {ActivityService} from "@/utilities/services/entities/ActivityService";
import {LocationService} from "@/utilities/services/entities/LocationService";
import {checkboxColumnConfig} from "@/AppConfig";
//import Activities from '@/views/Activities.vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ActivitySetEditPopup',
  props: {
  data: Object
},
  setup(__props) {

const props = __props


const popupData = toRef(props, 'data');


const gridStore = new Store();
const globalStore = useGlobalStore();
const { t } = useI18n();
const activityService = new ActivityService();
const locationService = new LocationService();

const loading = ref(true);
const activityList = ref([]);
const selectedActivities = ref([]);
const selectedLocations = ref([]);



// helpers
function uniqueBy(arr: any[]): any[] {
  const seen = new Set<string | number>();
  const out: any[] = [];
  for (const a of arr ?? []) {
    const k = (a?.id ?? a?.name ?? a) as string | number;
    if (k == null || seen.has(k)) continue;
    seen.add(k);
    out.push(a);
  }
  return out;
}

function toUniqueIds(arr: any[]): Array<string | number> {
  const ids = (arr ?? []).map(a => (a && typeof a === 'object') ? (a.id ?? a.value ?? a.key) : a);
  return Array.from(new Set(ids.filter(v => v != null))) as Array<string | number>;
}

const syncActivities = (newSelection: any[]) => {
  const unique = uniqueBy(newSelection);   // unique activityIds
  selectedActivities.value = unique;
  popupData.value.activities = unique;                
  popupData.value.activityIds = toUniqueIds(unique);   // unique activityIds
};


const activityGridFilter = {
  id: "filterOutOtherActivitySets",
  filterBy: (record)=> record.activitySetId === null || record.activitySetId === popupData.value.id
}
const toggleActivityGridFilter = ({target}:any)=>{
  if (target.checked){
    gridStore.removeFilter(activityGridFilter.id);
  }
  else{
    gridStore.filter(activityGridFilter);
  }
};

const grid = ref(null);
const useGridConfig = {
  height: "400px",
  headerMenuFeature: false,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true,
  },
  columns : {
    data: [
      {
        id: 'name',
        field : 'name',
        text: t('popups.activitySet.location'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'typeLevel',
        field : 'typeLevel',
        text: t('popups.activitySet.group2'),
        flex   : 1,
        sortable: true
      },
      {
        id: 'group1Name',
        field : 'netzCenter',
        text: t('popups.activitySet.group1'),
        flex   : 1,
        sortable: true
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.activitySetEditLocation], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
  listeners: {
    selectionChange(event) {
      if(event.selection.length > 0 && event.selection[0]?.data === undefined) return;
      selectedLocations.value = selectedLocations.value.concat(event.selected.map(lr => lr.data))
      selectedLocations.value = selectedLocations.value.filter(l => !event.deselected.map(lr => lr.data).includes(l));

      //convert full location object to smaller object type, that will also be returned by get API of get activitySet,
      //which is un equal to the selectable type, which is super fkn annoying, but there is no time to fix that atm
      // :( *sad programmer noises*
      popupData.value.activitySetLocationInfo = selectedLocations.value.map(l => {
        return {locationId:l.id, locationName:l.name};
      });
    },
  }
}
const gridConfig = reactive(useGridConfig);


const setGridData = async () => {
  loading.value = true;

  const locations = await locationService.getLocations("selectable", ErrorLocationType.popup);

  gridStore.setStoreData(locations);
  // filter out locations with another activitySet, can be toggled via checkbox
  gridStore.filter(activityGridFilter);

  // set selected locations in table
  grid.value.instance.value.selectRows(popupData.value.activitySetLocationInfo.map(l => l.locationId ?? l.id))

  globalStore.reorderColumns(TableType[TableType.activitySetEditLocation]);

  loading.value = false;
}

const setActivityDropDown = async () => {
  loading.value = true;

  activityList.value = await activityService.getActivities("display", ErrorLocationType.popup);

  // deduplicate what comes from the backend
  const unique = uniqueBy(popupData.value.activities);
  selectedActivities.value = unique;
  popupData.value.activities = unique;
  popupData.value.activityIds = toUniqueIds(unique); 

  loading.value = false;
}

onMounted(async () => {
  globalStore.modal.validator = v$;
  globalStore.setGridStore(ref(gridStore));
  globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

  await setGridData()
  await setActivityDropDown()
})

onBeforeUnmount(()=>{
  globalStore.setGridStore(null);
  globalStore.setGridColumnStore(null);

  globalStore.currentItems = 0;
  globalStore.allItems = 0;
});

// Validation

const rules = computed(() => {
  const rules = {
    name: { required: helpers.withMessage(t('validators.required'), required) },
  }
  return rules
})

const v$ = ref(useVuelidate(rules, popupData))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('popups.activitySet.description')) + " * ", 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass({ error: v$.value.name.$errors.length })
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "w-full",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupData).name) = $event))
              }, null, 512), [
                [_vModelText, _unref(popupData).name]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.name.$errors, (error) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "input-errors",
                  key: error.$uid
                }, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(error.$message), 1)
                ]))
              }), 128))
            ], 2)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('popups.activitySet.addActivity')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Tags), {
              options: activityList.value,
              selected: selectedActivities.value,
              onSelectChanged: syncActivities
            }, null, 8, ["options", "selected"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("h4", _hoisted_10, _toDisplayString(_unref(t)('popups.activitySet.locationsHeadline')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("input", {
                  id: "activityFilterToggle",
                  type: "checkbox",
                  onChange: toggleActivityGridFilter
                }, null, 32)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('popups.activitySet.toggleActivityFilter')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ], 512), [
          [_vShow, !loading.value]
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_17, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, loading.value]
      ])
    ])
  ]))
}
}

})